module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<!-- Получаем срендеренные свои и чужие значения -->\n")
    ;  var result = card[block](); 
    ; __append("\n\n<!-- Если есть хоть какое-нибудь значение -->\n")
    ;  if (card.isDefined(result)) { 
    ; __append("\n\n<div class=\"section\">\n	<div class=\"title\">")
    ; __append(escapeFn( title ))
    ; __append("</div>\n	<div>\n		<!-- Показываем свои данные -->\n		")
    ; __append( card.renderNative(result) )
    ; __append("\n\n		<!-- Показываем чужие данные -->\n		")
    ; __append( card.renderForeign(result) )
    ; __append("\n\n		<!-- Показываем список элементов, если нужно -->\n		")
    ;  if (typeof(list) != "undefined" && list) { 
    ; __append("\n		<ul>\n			")
    ;  var results = card[list](); 
    ; __append("\n\n			")
    ;  Util.each(results, function (result) { 
    ; __append("\n			<li>\n				")
    ; __append( card.renderNative(result) )
    ; __append("\n\n				")
    ; __append( card.renderForeign(result) )
    ; __append("\n			</li>\n			")
    ;  }); 
    ; __append("\n		</ul>\n		")
    ;  } 
    ; __append("\n	</div>\n</div>\n\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}